import React from "react";
import BilingualInvoicePrint from "../../../components/invoice/BilingualInvoicePrint";

const PrintInvoiceShipForMe: React.FC = () => <BilingualInvoicePrint kind="shipForMe" />;

export default PrintInvoiceShipForMe;
